var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.row.isEdited)?_c('b-button',{staticClass:"p-1",attrs:{"variant":"success","size":"sm"},on:{"click":function($event){return _vm.$emit('save', _vm.row)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'save']}}),_vm._v(" Save\n  ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }